import '@babel/polyfill'
import 'mutationobserver-shim'
// vue
import Vue from 'vue'

import acl from './plugins/aclPlugin.js'
Vue.use(acl)

// vueLazyLoad
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  loading: process.env.BASE_URL + 'img/imageLoading.png',
  error: process.env.BASE_URL + 'img/image404.png',
})

// vueDebounce
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

// VueHtmlToPaper
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    './assets/styles/print.css',
  ]
}

Vue.use(VueHtmlToPaper, options);

// bugsnag
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

if (process.env.NODE_ENV == 'production') {
    window.bugsnagClient = bugsnag({
    apiKey: 'c9707eafce0407c9f9881d85c79f8228',
    notifyReleaseStages: ['production']})

    bugsnagClient.use(bugsnagVue, Vue)
}

// filters
import Filters from './mixins/app/Filters';
Vue.mixin(Filters); 

// bootstrap vue
import './plugins/bootstrap-vue'

// application
import App from './App.vue'
import router from './router'
import store from './store'

import './registerServiceWorker'
import Multiselect from 'vue-multiselect'

window.axios = require('axios');

// ui components
Vue.component('text-input', require('./components/ui/TextInput.vue').default)
Vue.component('date-input', require('./components/ui/DateInput.vue').default)
Vue.component('app-month-select', require('./components/ui/AppMonthSelect.vue').default)
Vue.component('select-input', require('./components/ui/SelectInput.vue').default)
Vue.component('search-input', require('./components/ui/SearchInput.vue').default)
Vue.component('search-input-option', require('./components/ui/SearchInputOption.vue').default)
Vue.component('number-input', require('./components/ui/NumberInput.vue').default)
Vue.component('password-input', require('./components/ui/PasswordInput.vue').default)
Vue.component('mask-input', require('./components/ui/MaskInput.vue').default)
Vue.component('search-select-input', require('./components/ui/SearchSelectInput.vue').default)

// loadings
Vue.component('app-loading', require('./components/AppLoading.vue').default)

// alerts
Vue.component('app-alert', require('./components/AppAlert.vue').default)

// error handlers
Vue.component('error-handler', require('./components/ErrorHandler.vue').default)

Vue.component('multiselect', Multiselect)

// app init
Vue.config.productionTip = false



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

